import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Pay from './components/Pay';
import reportWebVitals from './reportWebVitals';

// Simple routing based on window.location.pathname

  const path = window.location.pathname;
  const root = ReactDOM.createRoot(document.getElementById('root'));

  if (path === '/pay') {
    root.render(
      <React.StrictMode>
        <Pay />
      </React.StrictMode>
    );
  } 
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );



// Initial render


// Listen for URL changes


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
